let promise;

/**
 * Taken directly from Google developers guide on how to detect browser support for WebP.
 *
 * @see https://developers.google.com/speed/webp/faq#in_your_own_javascript
 * @return {Promise<boolean>}
 */
export default function hasWebpSupport() {
  // cache the result, so that this function runs only once
  if (!promise) {
    promise = new Promise(resolve => {
      // basic support. other test forms exist for lossless, alpha, and animation types.
      // check google guide if data strings are needed
      const lossy = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
      const img = document.createElement('img');
      img.onload = function onLoad() {
        const result = img.width > 0 && img.height > 0;
        resolve(result);
      };
      img.onerror = function onError() {
        resolve(false);
      };
      img.src = `data:image/webp;base64,${lossy}`;
    });
  }
  return promise;
}